import { collections } from "@/mocks/community";
import SectionHeading from "./SectionHeading";

const toneMap = {
  primary: "bg-primary-500 text-background-50",
  accent: "bg-accent-500 text-foreground-950",
  secondary: "bg-secondary-500 text-background-50",
} as const;

export default function Collections() {
  return (
    <section id="collections" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          index="02"
          title="专题合集 · 按主题找片"
          subtitle="按题材、心情与口碑打包好的片单，跟着合集一路看下去"
          actionLabel="全部专题"
          actionHref="#collections"
        />
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {collections.map((item) => (
            <a
              key={item.id}
              href="#collections"
              className="group relative block h-[200px] overflow-hidden rounded-xl md:h-[230px]"
            >
              <img
                src={item.cover}
                alt={`${item.name} - 久久视频专题合集`}
                title={`${item.name} 高清影视专题`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-transparent"></div>
              <span
                className={`absolute right-3 top-3 rounded-full px-2.5 py-1 text-xs font-medium ${toneMap[item.tone]}`}
              >
                {item.count}
              </span>
              <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
                <h3 className="font-heading text-xl text-background-50 md:text-2xl">{item.name}</h3>
                <p className="mt-1 text-xs text-background-100/85 md:text-sm">{item.intro}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs text-accent-400 opacity-0 transition-opacity group-hover:opacity-100">
                  进入合集
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}